import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareQ = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler16') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler16', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Monkey tail!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Monkey tail!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareQ}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareQ
  
